module.exports = __webpack_public_path__ + "img/log_blue.7b06915c.svg";